import React, { useState } from "react"

import Description from "./Description"
import Amenities from "./Amenities"
import Location from "./Location"
import ReviewSection from "./ReviewSection"

import TabItem from "./TabItem"

import "./TabSection.scss"

const TabSection = (props) => {
  const [activeTab, setActiveTab] = useState(0)

  const tabItems = [
    {
      name: "one",
      title: "Description",
      component: <Description {...props} />,
    },
    {
      name: "two",
      title: "Amenities",
      component: <Amenities {...props} />,
    },
    {
      name: "three",
      title: "Location",
      component: <Location {...props} />,
    },
    {
      name: "four",
      title: "Reviews",
      component: <ReviewSection {...props} />,
    },
  ]

  return (
    <section className="tab-section">
      <div className="tab-section__tabs">
        {tabItems.map(({ id, name, title }, index) => (
          <TabItem
            key={title}
            name={name}
            title={title}
            onItemClicked={() => setActiveTab(index)}
            isActive={index === activeTab}
          />
        ))}
      </div>
      <div className="tab-section__divider" />
      <div className="tab-section__tabs__body">
        {tabItems[activeTab].component}
      </div>
    </section>
  )
}

export default TabSection
